import { createApiResponseSchema } from "@/types/common/pagination";
import { GroupSchema } from "@/types/entities/approval-groups";
import axios from "@/utils/axios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { z } from "zod";

export const ApiGroupResponseSchema = createApiResponseSchema(GroupSchema);
export type ApiGroupResponseType = z.infer<typeof ApiGroupResponseSchema>;

export type GroupsFiltersProps = {
  page?: number;
  per_page?: number;
  search?: string;
  type?: string;
  order_by?: string;
};

export const useGetGroups = (filters: GroupsFiltersProps) => {
  const queryParams = {
    page: filters.page || 1,
    per_page: filters.per_page || 10,
    search: filters.search || "",
    order_by: filters.order_by || "name",
  };
  return useQuery({
    queryKey: ["groups", queryParams],
    queryFn: async (): Promise<ApiGroupResponseType> => {
      const response = await axios.get("/admin/v1/groups", {
        params: {
          ...queryParams,
          relationships: "members",
          filter: {
            ...(filters.search && {
              search: filters.search,
            }),
            ...(filters.type && {
              type: filters.type,
            }),
          },
        },
      });
      return response.data;
    },
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};
